import { buttonShuffle, scatterButtons } from "../helpers-board.js";

/*
 * Adds an overlay to the window that looks like a flashlight being shined
 * */
function flashlight({ uiState, buttons, board, event, registerCleanup, initialPositions }) {
  if (uiState.flashlightActivated) return;
  uiState.flashlightActivated = true;

  const darkDiv = document.createElement("div");
  darkDiv.classList.add("flashlight");
  document.body.prepend(darkDiv);

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
  }

  // const ball = document.getElementById("ball");

  if (isMobileDevice()) {
    // ball.style.backgroundColor = "red";
    buttonShuffle({ board, buttons, initialPositions });
    window.addEventListener("deviceorientation", handleOrientation);
  }
  else {
    // ball.style.backgroundColor = "blue";
    scatterButtons({ buttons, board });
    document.addEventListener('mousemove', handleMouseMove);
  }

  buttons.forEach((button) => {
    if (button !== event.target) {
      button.addEventListener("click", () => { darkDiv.remove() }, { once: true })
    }
  })

  function cleanup() {
    darkDiv.remove();
    uiState.flashlightActivated = "false";

    if (isMobileDevice()) {
      window.removeEventListener("deviceorientation", handleOrientation);
    }
    else {
      document.removeEventListener('mousemove', handleMouseMove);
    }
  }


  // setTimeout(() => { board.addEventListener("click", cleanup) }, 1);
  // registerCleanup(() => { setTimeout(() => { board.addEventListener("click", cleanup) }, 1) });
  // registerCleanup(removeFlashlight);
  registerCleanup(cleanup);

}

function handleMouseMove(event) {
  const darkDiv = document.querySelector(".flashlight");
  if (darkDiv === null) return;
  const darkDivRect = darkDiv.getBoundingClientRect();
  darkDiv.style.top = `${event.clientY - (darkDivRect.height / 2)}px`;
  darkDiv.style.left = `${event.clientX - (darkDivRect.width / 2)}px`;
}

function handleOrientation(event) {
  const darkDiv = document.querySelector(".flashlight");
  const darkDivRect = darkDiv.getBoundingClientRect();
  //
  // Back to front rotation value (Y)
  let beta = event.beta; //[-180, 180)

  // Side to side rotation value
  let gamma = event.gamma; // [-90, 90) (X)

  // Make gamma easier to work with by making the scale 0 to 180
  gamma += 90;

  if (beta < 0) { beta = 0 };
  if (beta > 90) { beta = 90 };

  const maxX = window.innerWidth;
  const maxY = window.innerHeight;
  darkDiv.style.top = `${beta / 90 * maxY - (darkDivRect.height / 2)}px`;
  darkDiv.style.left = `${gamma / 180 * maxX - (darkDivRect.width / 2)}px`;
}


export default flashlight;

